/**
 * Component overrides (i.e. global styles, default props) applied to
 * MuiTypography to make it match the design system.
 *
 * See: https://mui.com/material-ui/api/typography/#css
 */ export const MuiTypography = {};

//# sourceMappingURL=typography-overrides.js.map